import { FC } from 'react';
import {
  getWeekRange,
  isCurrentWeek,
  WeekTargetType,
} from '../../../businessLogicService/dateHandlerForTeacherDashboard';
import { Button } from 'primereact/button';

interface Props {
  date: string;
  setDate: (d: string) => void;
}
const SkillChallengeAttemptedTableHeader: FC<Props> = ({ date, setDate }) => {
  const weekHandle = (weekTargetType: WeekTargetType) => {
    const newDate = getWeekRange(date, weekTargetType);
    setDate(newDate);
  };
  const nextDisabled = isCurrentWeek(date);

  return (
    <div className="flex justify-content-between align-items-center sm:col-12 md:flex-row flex-column">
      <h1 className="xl:col-8 md:text-lg md:col-6 text-base ">Skill Challenges attempted per student</h1>
      <div className="flex align-items-center justify-content-end xl:col-4 md:col-6" id="SkillChallengesWeekPicker">
        <Button
          style={{ borderRadius: '1rem 0 0 1rem', height: 'stretch' }}
          icon="pi pi-angle-left"
          outlined
          onClick={() => weekHandle(WeekTargetType.PREVIOUS)}
          aria-label={'Previous week'}
        />
        <label className="tw-font-atkinson" style={{ border: '1px solid', borderColor: '#1259fb', padding: '0.5rem' }}>
          {date}
        </label>
        <Button
          style={{
            borderRadius: '0 1rem 1rem 0',
            ...(nextDisabled ? { color: '#808080', borderColor: '#808080', height: 'stretch' } : { height: 'stretch' }),
          }}
          icon="pi pi-angle-right"
          outlined
          onClick={() => weekHandle(WeekTargetType.NEXT)}
          disabled={nextDisabled}
          aria-label={'Next week'}
        />
      </div>
    </div>
  );
};

export default SkillChallengeAttemptedTableHeader;
